import _ from 'lodash';
import { padLeadingZeros } from './numbers';

/**
 * getWorkUrl returns the URL for a work, formatting the bkWorkId when needed
 * @param {Number} bkWorkId the bkWorkId
 * @param {String} country the country string to append to the URL returned
 * @returns {String}
 */
export function getWorkUrl(bkWorkId, country = '') {
    let bWID = bkWorkId;
    let countryString = '';
    if (country !== '') {
        countryString = '/' + country;
    }
    // For MLC works (negative bkWorkIds), mask the negative bkWorkId in the URL
    if (bWID < 0) {
        bWID = padLeadingZeros(Math.abs(bWID), 1);
    }
    return `/work/${bWID}${countryString}`;
}

/**
 * formatBkWorkId formats a bkWorkId for use in API calls. This is needed as
 * negative bkWorkIds (MLC Works) are masked with a 0 in the URL
 * @param {string} bkWorkId
 * @returns {string}
 */
export function formatBkWorkId(bkWorkId) {
    if (_.startsWith(bkWorkId, '0')) {
        bkWorkId = '-' + _.trimStart(bkWorkId, '0');
    }
    return bkWorkId;
}
